// extracted by mini-css-extract-plugin
module.exports = {"originByline":"OriginByline_originByline__wPESD"};